import styled, { css } from 'styled-components';
import { space } from 'styled-system';
var backgroundColorTypeToTextColorMap = {
  light: 'primary500',
  primary: 'white',
  green: 'white',
  // For backwards compatibility
  dark: 'white'
};
var backgroundColorTypeToActiveColorMap = {
  light: 'primary700',
  primary: 'gray100',
  green: 'gray100',
  // For backwards compatibility
  dark: 'gray200'
};
var backgroundColorTypeToDisabledColorMap = {
  light: 'gray200',
  primary: 'primary700',
  green: 'primary700',
  // For backwards compatibility
  dark: 'gray800'
};

var getColorUsingBackgroundColorMap = backgroundColorMap => css(["", ";"], p => p.theme.colors[backgroundColorMap[p.backgroundColorType]]);

export var enabledLinkTextStyles = /*#__PURE__*/css(["color:", ";&::selection{color:", ";}&:hover{text-decoration:underline;text-decoration-color:", ";}&:active{color:", ";&:hover{text-decoration-color:", ";}}"], getColorUsingBackgroundColorMap(backgroundColorTypeToTextColorMap), getColorUsingBackgroundColorMap(backgroundColorTypeToTextColorMap), getColorUsingBackgroundColorMap(backgroundColorTypeToTextColorMap), getColorUsingBackgroundColorMap(backgroundColorTypeToActiveColorMap), getColorUsingBackgroundColorMap(backgroundColorTypeToActiveColorMap));
var disabledLinkTextStyles = /*#__PURE__*/css(["color:", ";&::selection{color:", ";}cursor:default;"], getColorUsingBackgroundColorMap(backgroundColorTypeToDisabledColorMap), getColorUsingBackgroundColorMap(backgroundColorTypeToDisabledColorMap));
export var StyledLinkText = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__StyledLinkText",
  componentId: "sc-1yoqaw6-0"
})(["h1,h2,h3,h4,h5,h6,p,span,div,label{", ";display:inline-block;", ";}"], space, p => p.disabled ? disabledLinkTextStyles : enabledLinkTextStyles);
export var StyledLinkComponentChild = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__StyledLinkComponentChild",
  componentId: "sc-1yoqaw6-1"
})(["", ";display:inline-block;"], space);
export var LinkAnchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "style__LinkAnchor",
  componentId: "sc-1yoqaw6-2"
})(["text-decoration:none;color:unset;"]);